import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type ApolloResult } from "../../shared/models";
import {
    type OrgForMigratedAssetsQuery,
    type OrgForMigratedAssetsQueryVariables,
    orgForMigratedAssets,
} from "../api/queries";

interface MigratedAssetsResult {
    hasMigratedAssets: boolean;
    assets: string[];
    organizationName: string;
}

export const useOrgForMigratedAssets = (): ApolloResult<MigratedAssetsResult> => {
    const { data, loading, error } = useQuery<OrgForMigratedAssetsQuery, OrgForMigratedAssetsQueryVariables>(
        orgForMigratedAssets,
    );

    return useMemo(() => {
        return {
            loading,
            error,
            hasMigratedAssets: (data?.orgForMigratedAssets.assets ?? []).length > 0,
            organizationName: data?.orgForMigratedAssets.organizationName ?? "",
            assets: [...(data?.orgForMigratedAssets.assets ?? [])],
        };
    }, [loading, error, data?.orgForMigratedAssets]);
};
